import aggregators from './aggregators'

// const report = require('../../../tests/unit/pivot/report')
// const data = report.dataSource.data
// const slice = report.slice

export default function pivot (data, slice) {
  if (!slice.measures.length ||
      (!slice.rows.length && !slice.columns.length)) {
    return null
  }

  const aggregator = slice.measures[0].aggregation

  // Content of the pivot table:
  // rows and columns sub-totals
  const rows = {}
  const cols = {}
  // all values in the middle of the table
  const rowsCols = {}
  // grand total
  let total = new aggregators[aggregator]()

  // contains all possible values of rows and cols
  const rowValues = new Set()
  const colValues = new Set()

  // Setup
  // - init rowKeys and colKeys
  // - parse dates
  const RE_DATE = /(\d{4})-(\d{2})-(\d{2})/
  let m
  for (const d of data) {
    for (const f in d) {
      if (!d[f] || !d[f].match) { continue }

      m = d[f].match(RE_DATE)
      if (m) {
        d[f] = { Year: parseInt(m[1]), Month: parseInt(m[2]), Day: parseInt(m[3]) }
      }
    }

    if (slice.rows.length) {
      rowValues.add(getProp(d, slice.rows[0].uniqueName))
    }

    if (slice.columns.length) {
      colValues.add(getProp(d, slice.columns[0].uniqueName))
    }
  }

  // init all cells of the pivot table, even the empty one
  // this is necessary to avoid errors in the chart creation!
  for (const r of rowValues) {
    rows[r] = new aggregators[aggregator]()
    rowsCols[r] = {}
    for (const c of colValues) {
      cols[c] = new aggregators[aggregator]()
      rowsCols[r][c] = new aggregators[aggregator]()
    }
  }

  for (const c of colValues) {
    cols[c] = new aggregators[aggregator]()
  }

  // Aggregate data
  for (const d of data) {
    // Check if column and rows aggregation are defined
    const rowVal = slice.rows.length ? getProp(d, slice.rows[0].uniqueName) : null
    const colVal = slice.columns.length ? getProp(d, slice.columns[0].uniqueName) : null
    // Measure is defined for sure here
    const meaVal = getProp(d, slice.measures[0].uniqueName)

    // row/colVal can be undefined and it's a valid value
    // so just check if the pivot data is defined
    if (slice.rows.length) { rows[rowVal].push(meaVal) }
    if (slice.columns.length) { cols[colVal].push(meaVal) }
    if (slice.rows.length && slice.columns.length) { rowsCols[rowVal][colVal].push(meaVal) }
    total.push(meaVal)
  }

  // Generate chart data
  const chartData = []

  chartData.push({ v0: total.value })

  for (let r in rows) {
    chartData.push({
      r0: r !== 'undefined' ? r : '-',
      v0: rows[r].value
    })
  }

  for (let c in cols) {
    chartData.push({
      c0: c !== 'undefined' ? c : '-',
      v0: cols[c].value
    })
  }

  for (let r in rowsCols) {
    for (let c in rowsCols[r]) {
      chartData.push({
        r0: r !== 'undefined' ? r : '-',
        c0: c !== 'undefined' ? c : '-',
        v0: rowsCols[r][c].value
      })
    }
  }

  const meta = {}

  if (slice.rows.length) {
    meta.rAmount = slice.rows.length
    meta.r0Name = slice.rows[0].uniqueName
  }

  if (slice.columns.length) {
    meta.cAmount = slice.columns.length
    meta.c0Name = slice.columns[0].uniqueName
  }

  meta.vAmount = slice.measures.length
  meta.v0Name = `${aggregator} of ${slice.measures[0].uniqueName}`

  return { data: chartData, meta }
}

// https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_get
const getProp = (obj, path, defaultValue) => {
  const result = String.prototype.split.call(path, /[,[\].]+?/)
    .filter(Boolean)
    .reduce((res, key) => (res !== null && res !== undefined) ? res[key] : res, obj)
  return (result === undefined || result === obj) ? defaultValue : result
}
